export const acisServers = {
    StnMeta: "https://data.rcc-acis.org/StnMeta",
    StnData: "https://data.rcc-acis.org/StnData",
    MultiStnData: "https://data.rcc-acis.org/MultiStnData",
    GridData: "https://data.rcc-acis.org/GridData",
    GridData2: "https://grid2.rcc-acis.org/GridData",
    StnHourly: "https://data.nrcc.rcc-acis.org/StnData",
    General: "https://data.rcc-acis.org/General/",
}